import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Card, Typography, message, Divider, Tabs, Button, Dropdown, Space, Avatar, Modal } from "antd";
import {
  CarryOutOutlined,
  EditOutlined,
  AlignRightOutlined,
  DownloadOutlined,
  UserOutlined,
  RightCircleOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
import { ProblemasAcoes } from "./components/acoes";
import { Problema } from "./components/problema";
import { AuthContext } from "../../../contexts/AuthContext";
const { Text } = Typography;

export const ProblemasDetalhes = ({ tab }) => {
  const { id_problema } = useParams();
  const { session } = useContext(AuthContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState(null);
  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {
    if (id_problema > 0) {
      carregarProblema(id_problema);
    }
  }, [id_problema]);

  const carregarProblema = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/problemas/carregar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
      navigate({
        pathname: "/planos-acao",
        search: `?tab=${tab}`,
      });
    }
    setLoading(false);
  };

  const alterarStatus = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/problemas/alterar_status`, formulario);
    if (api.statusCode === 200) {
      carregarProblema(formulario?.id);
      message.success("Registro alterado com sucesso!");
    } else {
      carregarProblema(formulario?.id);
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const baixarRelatorio = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("file", `v1/problemas/baixar_relatorio/${id}`, []);
    if (api.statusCode === 200) {
      const url = window.URL.createObjectURL(api?.response?.data);
      let a = document.createElement("a");
      a.href = url;
      a.download = "relatorio.pdf";
      a.click();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const baixarRelatorioCompleto = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("file", `v1/problemas/baixar_relatorio_completo/${id}`, []);
    if (api.statusCode === 200) {
      const url = window.URL.createObjectURL(api?.response?.data);
      let a = document.createElement("a");
      a.href = url;
      a.download = "relatorio.zip";
      a.click();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const iniciarProblema = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("post", `v1/problemas/iniciar_atendimento`, {
      id: id,
    });
    if (api.statusCode === 200) {
      carregarProblema(id);
      message.success("Plano de Ação iniciado com sucesso!");
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  const items = [
    {
      key: "1",
      label: (
        <span>
          <AlignRightOutlined />
          Detalhes
        </span>
      ),
      children: <Problema problema={dados} loadingData={loading} alterarStatus={alterarStatus} />,
    },
    {
      key: "2",
      label: (
        <span>
          <EditOutlined />
          Ações
        </span>
      ),
      children: <ProblemasAcoes problema={dados} atualizarStatus={alterarStatus} />,
    },
  ];

  const items_dropdown = [
    {
      key: "1",
      label: "Relatório simplificado",
      onClick: () => baixarRelatorio(dados?.id),
    },
    {
      key: "2",
      label: "Relatório completo",
      onClick: () => baixarRelatorioCompleto(dados?.id),
    },
  ];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={24} lg={24} xl={23} xxl={20} align="left">
          <div className="content-item">
            <HeaderPage
              title="Planos de Ação"
              onClickBack={() =>
                navigate({
                  pathname: "/planos-acao",
                  search: `?tab=${tab}`,
                })
              }
            />
            <HeaderTitle
              title="Planos de Ação Detalhes"
              subtitle={
                <Text italic>
                  <CarryOutOutlined /> {dados?.id ?? ""}
                </Text>
              }
              icon={<CarryOutOutlined />}
              loading={loading}
            />
            <Divider />

            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Col span={24} style={{ marginBottom: 20 }}>
                <Space size={15}>
                  <Avatar style={{ backgroundColor: "#87d068" }} icon={<UserOutlined />} />
                  <Space direction="vertical" size={0}>
                    <Text type="secondary">Atendente</Text>
                    <Text strong>{dados?.id_colaborador_atendente > 0 ? dados?.atendente : "-"}</Text>
                  </Space>
                  {dados?.id_colaborador_atendente !== session?.usuario?.id_colaborador &&
                    dados?.responsaveis?.includes(session?.usuario?.id_colaborador) &&
                    [-1, 3].includes(dados?.status) && (
                      <Button
                        icon={<RightCircleOutlined />}
                        type="primary"
                        loading={loading}
                        onClick={() => {
                          modal.confirm({
                            title: `Deseja ${
                              dados?.id_colaborador_atendente > 0 ? "assumir" : "iniciar"
                            } este plano de ação?`,
                            okText: "Sim",
                            cancelText: "Cancelar",
                            onOk() {
                              iniciarProblema(dados?.id);
                            },
                          });
                        }}>
                        {dados?.id_colaborador_atendente > 0 ? "Assumir" : "Iniciar"}
                      </Button>
                    )}
                </Space>
                <Divider />
              </Col>

              <Tabs
                type="card"
                size="large"
                defaultActiveKey="2"
                items={items}
                tabBarExtraContent={{
                  right: (
                    <Dropdown menu={{ items: items_dropdown }}>
                      <Button type="text" icon={<DownloadOutlined />} loading={loading}>
                        Download
                      </Button>
                    </Dropdown>
                  ),
                }}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
